const data = {
  text: 'Schedule an initial meeting now',
  subline: 'Click here and choose a free appointment',
  link: '100 % free & non-binding initial consultation'
}

export default data
